document.addEventListener('DOMContentLoaded', function () {
    const singleProduct = document.querySelector('.single-product-content')
    if (!singleProduct) return
    const buttons = singleProduct.querySelectorAll('.variation-button')
    if (buttons.length === 0) return
    for (const button of buttons) {
        const variationValue = parseFloat(button.dataset.variationValue)
        if (variationValue >= liGlobal.defaultProductQty) {
            button.classList.add('selected')
            button.dispatchEvent(new Event('click', { bubbles: true }))
            // Stop the loop if we found a valid variation
            break
        }
    }
})

function handleVariationSelection(button) {
    const singleProduct = button.closest('.single-product-content')
    if (!singleProduct) return
    const buttons = singleProduct.querySelectorAll('.variation-button')
    if (buttons.length === 0) return
    const variationSelect = singleProduct.querySelector('select#pa_antal')
    const buttonValue = button.dataset.variationValue
    const selectedVariation = singleProduct.querySelector('.selected-variation')

    buttons.forEach((button) => {
        button.classList.remove('selected')
    })
    button.classList.add('selected')
    variationSelect.value = buttonValue
    variationSelect.dispatchEvent(new Event('change', { bubbles: true }))

    if (selectedVariation) {
        selectedVariation.querySelector('.selected-variation-price').textContent =
            button.querySelector('.price').textContent
        selectedVariation.querySelector('.selected-variation-name').textContent = button.dataset.variationValue
    }
}

document.addEventListener('click', function (e) {
    if (e.target.closest('.variation-button')) {
        handleVariationSelection(e.target.closest('.variation-button'))
    }

    // Fix för att kunna växla mellan prenumeration och engångsköp korrekt tillsammans med AJAX.
    // När man klickar på prenumeration och lägger något i varukorgen måste man sen resetta formuläret för att på ett korrekt sätt kunna växla tillbaka till engångsköp.
    if (e.target.closest('.wcsatt-options-prompt-radios li:first-child')) {
        const liFirstChild = e.target.closest('.wcsatt-options-prompt-radios li:first-child')
        const input = liFirstChild.querySelector('input')
        const form = liFirstChild.closest('form.cart')

        setTimeout(() => {
            // Resetta formuläret
            form.reset()
            // Markera första radioknappen som vald
            input.checked = true
            // Klicka på den valda varianten för att uppdatera formuläret med rätt värde
            if (document.querySelector('.variation-button.selected')) {
                document
                    .querySelector('.variation-button.selected')
                    .dispatchEvent(new Event('click', { bubbles: true }))
            }
        }, 100)
    }

    // Scroll to subscription options if clicking on subscription button
    if (e.target.closest('.wcsatt-options-prompt-radios li:last-child')) {
        const subscribeWrapper = document.querySelector('.wcsatt-options-product-wrapper')

        if (subscribeWrapper) {
            setTimeout(() => {
                // Scroll on mobile
                const rect = subscribeWrapper.getBoundingClientRect()
                if (window.innerWidth < 768) {
                    window.scrollTo({
                        top: window.scrollY + rect.top - 160,
                        behavior: 'smooth',
                    })
                }

                // Make the select area blink to show it's active
                subscribeWrapper.classList.add('active')
                setTimeout(() => {
                    subscribeWrapper.classList.remove('active')
                }, 2000)
            }, 500)
        }
    }
})

document.addEventListener('click', function (e) {
    if (e.target.closest('.go-to-reviews')) {
        e.preventDefault()
        const reviews = document.querySelector('#reviews')
        const reviewDetails = reviews.closest('details')
        if (reviewDetails) {
            const rect = reviewDetails.getBoundingClientRect()
            window.scrollTo({
                top: window.scrollY + rect.top - 80,
                behavior: 'smooth',
            })
            reviewDetails.open = true
        }
    }
})
